import React, { useCallback } from "react";
import clsx from 'clsx';
import { withRouter, useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import URL from "../../../../constant/URL";
import http from "../../../../http/http";
import useAsideState from "../../../../hooks/useAsideState";
import MenuButton from "../../../navigate/MenuButton";
import HomeButton from "../../../navigate/HomeButton";
import { useUserInfo } from "../../../../hooks";
import { TYPE } from "../../../../constant";
import useAmplitude from "../../../../hooks/useAmplitude";

const Header = withRouter((props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { info } = useUserInfo();
  const { setAsideState } = useAsideState();
  const { setAmplitudeLog } = useAmplitude();
  const [levelWidth, setLevelWidth] = React.useState(0);
  const [level, setLevel] = React.useState('LV0');
  const [headerClass, setHeaderClass] = React.useState("header_gray_bg");

  const setTab = () => {
    setAsideState({tab: 'course'});
  };

  const moveLearningNote = () => {
    props.history.push({pathname: URL.COURSE_LEARNING.LEARNING_NOTE});
  };

  const getHearderLevel = () => {
    http.request({
      url: `${URL.API.LEARNING.COURSE}/level/channel/${info.channelCode}/language/KO/member/${info.learnerId}`,
      success: (res) => {
        let line = document.getElementById("learning_bar")?.clientWidth;
        let lineWidth =  (line/res.totalCnt)*res.endCnt;
        setLevelWidth(lineWidth);
        setLevel(`LV ${res.dspOdr}`);
        props.getLevel(res.lvlCd, res.dspOdr);
      }
    });
  };

  const changeClass = () => {
    if(props.headerClass){
      setHeaderClass(props.headerClass);
    }
  };

  const handlePage = useCallback((path) => {
    history.push(path);
  }, [history]);

  const handleMenuClick = useCallback(() => {
    setAsideState({ menu: true });
    setAmplitudeLog({ eventCategory: 'app_usage', eventName: '메인메뉴 조회'});
  }, []);

  React.useEffect(setTab, []);
  React.useEffect(getHearderLevel, []);
  React.useEffect(changeClass, [props]);

  return (
    <>
      {TYPE.CHANNEL.GLOBAL01 !== info.channelCode && <div className={headerClass}></div>}
      <div className={clsx(
        "header_top",
        TYPE.CHANNEL.GLOBAL01 === info.channelCode && 'gb bg_sky'
      )}>
        <div className="btns_wrap">
          <div className="center_wrap cls">
            <div className="tit_area cls">
              <HomeButton />
              <button
                className="btn_exit2"
                type="button"
                onClick={() => handlePage(URL.SELECT_LEARNING)}
              >
                <img src={`${process.env.PUBLIC_URL}/static/images/icon/ic_ar_left.svg`} alt="" />
              </button>
              <button
                className="tit_btn"
                type="button"
                onClick={() => handlePage(URL.SELECT_LEARNING)}
              >{t("LC_03_02.msg001")}</button>
            </div>
            <div className="right_area">
              <div className="lev_area">
                <div className="lev_box">
                  <div className="left">
                    <span>{level}</span>
                  </div>
                  <div className="right_area" id="learning_bar">
                    <div className="right" style={{width: levelWidth}}>
                      {TYPE.CHANNEL.GLOBAL01 !== info.channelCode && <div className="inner_bar"></div>}
                    </div>
                  </div>
                </div>
              </div>
              <div className="menu_btn">
                {
                  TYPE.CHANNEL.GLOBAL01 !== info.channelCode
                    ? (
                      <>
                        <button className="head_btn" type="button" onClick={moveLearningNote}>
                          <img src={`${process.env.PUBLIC_URL}/static/images/icon/ic_note_32@2x.png`} alt="" />
                        </button>
                        <MenuButton />
                      </>
                    )
                    : (
                      <>
                        {/* 로그인 버튼 */}
                        { info.memberType === TYPE.GB_USER_TYPE.GUEST &&
                          <button type="button" onClick={() => handlePage(URL.ACCOUNT.LOGIN)}>
                          <img src={`${process.env.PUBLIC_URL}/static/images/payment/ic_pay_login.svg`} alt="login"/>
                        </button>
                        }
                        <button type="button" onClick={handleMenuClick}>
                          <img src={`${process.env.PUBLIC_URL}/static/images/icon/btn_menu_th.svg`} alt="" />
                        </button>
                      </>
                    )
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );

});

export default Header;

